var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteSubMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.21875 4.63235H15.2188M7.71875 12.5735V7.80882M10.7188 12.5735V7.80882M12.2188 15.75H6.21875C5.39032 15.75 4.71875 15.0389 4.71875 14.1618V5.42647C4.71875 4.98789 5.05454 4.63235 5.46875 4.63235H12.9688C13.383 4.63235 13.7188 4.98789 13.7188 5.42647V14.1618C13.7188 15.0389 13.0472 15.75 12.2188 15.75ZM7.71875 4.63235H10.7188C11.133 4.63235 11.4688 4.27681 11.4688 3.83824V3.04412C11.4688 2.60554 11.133 2.25 10.7188 2.25H7.71875C7.30454 2.25 6.96875 2.60554 6.96875 3.04412V3.83824C6.96875 4.27681 7.30454 4.63235 7.71875 4.63235Z",
    stroke: "#F31825",
    strokeWidth: 1.50267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteSubMenu);
export default __webpack_public_path__ + "static/media/DeleteSubMenu.6714c1c4b590e13aeda033c8d97114c4.svg";
export { ForwardRef as ReactComponent };